export const RAYCAST_REDIRECT_URI = 'https://raycast.com/redirect?packageName=Extension';

export function parseRaycastRequest(search) {
    const params = new URLSearchParams(search);
    if (params.get('client_id') !== 'luckynote-raycast' ||
        params.get('redirect_uri') !== RAYCAST_REDIRECT_URI ||
        params.get('response_type') !== 'code' ||
        params.get('code_challenge_method') !== 'S256' ||
        !/^[A-Za-z0-9_-]{43}$/.test(params.get('code_challenge') || '') ||
        !/^[A-Za-z0-9_-]{16,512}$/.test(params.get('state') || '')) return null;
    return {
        extensionId: 'raycast',
        codeChallenge: params.get('code_challenge'),
        redirectUri: RAYCAST_REDIRECT_URI,
        state: params.get('state')
    };
}

export function raycastCallback(code, state) {
    const url = new URL(RAYCAST_REDIRECT_URI);
    url.searchParams.set('code', code);
    url.searchParams.set('state', state);
    return url.toString();
}

export function raycastLoginPath(search) {
    return `/login?redirect=${encodeURIComponent(`/raycast-auth${search}`)}`;
}

export function pendingRaycastReturn(search) {
    const target = new URLSearchParams(search).get('redirect');
    if (!target || !target.startsWith('/raycast-auth?')) return null;
    return parseRaycastRequest(target.slice('/raycast-auth'.length)) ? target : null;
}
